/*
 * (Trello 卡 6aab90b1e1dc16fd9ba865c0, 辉哥 9/17 15:01 拍板)
 * Hero image 上传按钮 (composer 用)
 *
 * 用途:
 *   - 在 DiscussionComposer 头部渲染 "上传头图 (16:9)" 按钮 + 预览
 *   - Admin + Mods 默认有 discussion.ziven-core.uploadHeroImage 权限才显示
 *   - 普通用户 composer 不显示此按钮 (跟辉哥 SOP 一致)
 *
 * (辉哥 9/17 22:04 拍板):
 *   - 去掉 HeroImageUpload-label 元素 (头图 (Hero Image) 文字标签)
 *   - 去掉 HelpText 元素 (帮助文字)
 *   - "上传头图" 按钮改 span + Button--ua-reset + 内层 HeroImageUpload-buttonLabel,
 *     模仿 vendor flarum-tags/js/src/forum/addTagComposer.js (L51-60) 选择标签按钮:
 *       外层 <span className="Button Button--ua-reset ..."> (vendor ua-reset 重置 UA button 默认样式)
 *       内层 <span className="HeroImageUpload-buttonLabel"> (模仿 vendor TagLabel untagged 浅色 dotted 边框样式)
 *       onclick 直接挂 span 上 (无 <button> HTML 元素)
 *   - preview 状态 (replace/remove Button) 保留 vendor Button 组件不变
 *   - 配套 CSS less/forum.less 同步改: 删 .HeroImageUpload-label 规则 + .HelpText 规则 +
 *     重写 .HeroImageUpload-button 模仿 vendor TagLabel untagged 风格
 *
 * (辉哥 9/17 22:13 拍板, UI 风格反馈):
 *   - 上面用 Button--primary 蓝色实心错了, 辉哥要的是模仿 vendor 选择标签的浅色 dotted 边框风格
 *   - 改 Button Button--ua-reset (vendor 浅色 UA reset)
 *
 * 流程:
 *   1. 按钮点击 → 弹 HeroImageCropModal
 *   2. 选本地图 → modal 强剪裁 16:9 (居中, 不可改) → toBlob
 *   3. 调用 uploadToCOS() → 拿到 CDN URL
 *   4. callback 通知 composer (attrs.onChange) → 写入 composer.data.heroImageUrl
 *   5. composer 发布时 DiscussionResource 接收 heroImageUrl 字段写入 DB
 *
 * 父组件 (modifyDiscussionComposer.js) 需要:
 *   - 监听 onChange 写入 composer.state.heroImageUrl
 *   - override DiscussionComposer.data() 返 { title, content, heroImageUrl }
 *   - 编辑现有讨论时同样支持 (update 流程)
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import HeroImageCropModal from './HeroImageCropModal';
export default class HeroImageUpload extends Component {
  /**
   * attrs (Flarum 2.0 Component base 把 attrs 存在 this.attrs, 不是 1.8 时代的 this.props):
   *   - value: 当前 hero image CDN URL (string | null)
   *   - onChange: (newUrl | null) => void, 通知父组件更新
   */
  view() {
    const _this$attrs = this.attrs,
      value = _this$attrs.value,
      onChange = _this$attrs.onChange;
    const hasImage = !!value;
    return m("div", {
      className: "HeroImageUpload Form-group"
    }, m("div", {
      className: "HeroImageUpload-control"
    }, hasImage ? m("div", {
      className: "HeroImageUpload-preview"
    }, m("img", {
      className: "HeroImageUpload-preview-image",
      src: value,
      alt: ""
    }), m("div", {
      className: "HeroImageUpload-actions"
    }, m(Button, {
      className: "Button Button--primary",
      onclick: () => this.openCropModal(value, onChange)
    }, app.translator.trans('ziven-community-core.forum.hero_image.replace')), m(Button, {
      className: "Button Button--danger",
      onclick: () => onChange(null)
    }, app.translator.trans('ziven-community-core.forum.hero_image.remove')))) : m("span", {
      className: "Button Button--ua-reset HeroImageUpload-button",
      role: "button",
      tabindex: "0",
      onclick: () => this.openCropModal(null, onChange)
    }, m("span", {
      className: "HeroImageUpload-buttonLabel"
    }, app.translator.trans('ziven-community-core.forum.hero_image.upload')))));
  }
  openCropModal(currentUrl, onChange) {
    app.modal.show(HeroImageCropModal, {
      currentUrl,
      onUpload: url => onChange(url)
    });
  }
}
flarum.reg.add('ziiven-ziven-core', 'forum/components/HeroImageUpload', HeroImageUpload);